<app-dialog [formGroup]="form" [noActions]="true">
  <div class="dialog-container">
    <p secondTitle class="title">Add email</p>
    <p subtitle class="description">Help us ensure correct profile match</p>

    <app-input>
      <input placeholder="Email" type="text" formControlName="email"/>
    </app-input>
    <button [disabled]="form.invalid" appButton (click)="onAdd()" type="submit" class="w-full action-button mb-6">
      Add
    </button>
  </div>
</app-dialog>


